<div class="inline-flex text-sm font-bold uppercase">
  {{ status() | paymentStatus | async }}
</div>
